<script>
  import { getContext } from 'svelte';
  export let word;
  export let score = 0;
  export let result;

  const app = getContext('app');
  $: show = app.context && app.context.devMode;
  $: score_round = score.toFixed(4);

  function printWhy (e) {
    e.stopPropagation();
    console.log(`Why '${word}'\n`, result);
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<i class="score" class:score--hidden={!show} on:click={printWhy}>{score_round}</i>

<style>
  .score {
    position: absolute;
    padding: 0 4px;
    bottom: 0;
    right: 0;
    background-color: var(--highlight);
    color: var(--textOnHighlight);
    font-size: 16px;
    transition: transform .2s;
  }

  .score:hover {
    transform: scale(1.2);
  }

  .score--hidden {
    display: none;
  }
</style>
